import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import Suite from "@/components/hotel/Suite";
import Footer from "@/components/hotel/Footer";
import SEO, { BASE_URL } from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const SuitePage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Suite"
        description="Luxuriöse Suite im ESOS Hotel Quelle Bad Ragaz – grosszügiger Wohnbereich, Küche, Kamin und erstklassiger Komfort."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Zimmer", path: "/rooms" },
          { name: "Suite", path: "/rooms/suite" },
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Suite",
          name: "Suite mit Galerie",
          description: "Luxuriöse Suite über zwei Etagen mit Wohnbereich, Küche, Kamin und Balkon.",
          url: `${BASE_URL}/rooms/suite`,
          bed: [
            { "@type": "BedDetails", typeOfBed: "Doppelbett", numberOfBeds: 1 },
            { "@type": "BedDetails", typeOfBed: "Einzelbett", numberOfBeds: 1 },
          ],
          occupancy: { "@type": "QuantitativeValue", minValue: 1, maxValue: 4 },
          amenityFeature: [
            { "@type": "LocationFeatureSpecification", name: "WLAN", value: true },
            { "@type": "LocationFeatureSpecification", name: "Küche", value: true },
            { "@type": "LocationFeatureSpecification", name: "Kamin", value: true },
            { "@type": "LocationFeatureSpecification", name: "Balkon", value: true },
            { "@type": "LocationFeatureSpecification", name: "Eigenes Bad", value: true },
          ],
        }}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.suite.title} subtitle={t.subpageHeroes.suite.subtitle} />
      <Suite />
      <Footer />
    </main>
  );
};

export default SuitePage;
